import React from 'react';

function Transactions() {
  return (
    <div className='transactions'>
      <h1>Transactions</h1>
    </div>
  );
}

export default Transactions;
